import React from "react";
import { ReactComponent as TickBefore } from "../../assets/TickBefore.svg";
import { ReactComponent as TickAfter } from "../../assets/TickAfter.svg";
import "./AINavigation.css";

const AINavigation = ({ navtabs, activeTab, setActiveTab, disabled }) => {
  return (
    <div className="ai-navigation-container">
      <div className="ai-navigation-tabs">
        {navtabs?.map((tab, index) => (
          <span
            key={tab.value}
            onClick={() => {
              if (!disabled) {
                setActiveTab(tab.value);
              }
            }}
            className={`ai-navigation-tab 
              ${activeTab === tab.value ? "active" : ""} 
              ${disabled ? "disabled" : ""}`}
          >
            {activeTab >= tab.value ? (
              <TickAfter className="tick-icon mt-2" />
            ) : (
              <TickBefore className="tick-icon mt-2" />
            )}{" "}
            {/* Tick icons */}
            <span className="tab-label">{tab.label}</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default AINavigation;
